module.exports = __webpack_public_path__ + "img/square_pipes.40b6122e.jpg";